import ModalComponent from '@components/modal/Modal.component';
import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import React, {useEffect, useState} from 'react';
import {Stack, Typography} from '@mui/material';
import NewTableComponent from '@components/table/NewTable.component';
import COLUMN_TYPES from '@utils/table/columnTypes.table';
import {useObservable} from '@ngneat/react-rxjs';
import {ChangeRate, changeRateQuery, changeRateService} from '@store/settings/changeRate';
import {GridValueGetterParams} from '@mui/x-data-grid-pro';
import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import {NumberExt} from '@utils/extensions/number.extension';

interface ChangeRateListModalProps {
  periodStart: Date;
  handleClose: () => void;
}

const ChangeRateListModal = (props: ChangeRateListModalProps) => {
  const {periodStart, handleClose} = props;
 
  const [{changeRates}] = useObservable(changeRateQuery.changeRates$);
  const [valueForNCHF, setValueForNCHF] = useState(1);

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    changeRateService.getChangeRates(periodStart).subscribe({
      error: err => enqueueSnackbar(err.text, err.options),
    });
  }, [enqueueSnackbar, periodStart]);

  console.log(changeRates);

  return (
    <ModalComponent
      title={t('settings.changeRate.modal.title')}
      handleClose={handleClose}
      maxWidth={false}
      content={(
        <Stack width="100%" spacing={2} pt="55px" pb="10px" height="85vh">
          <Stack direction="row" justifyContent="flex-end">
            <NumberTextFieldComponent
              centered={true}
              color="secondary"
              endAdornment={<Typography>CHF</Typography>}
              label={t('settings.changeRate.modal.valueForOneCHF')}
              value={valueForNCHF}
              handleChange={(value) => setValueForNCHF(value || 1)}
            />
          </Stack>
          <NewTableComponent
            columns={[
              COLUMN_TYPES.TEXT({
                field: 'name',
                label: t('settings.changeRate.modal.table.name'),
                valueGetter: (params: GridValueGetterParams<ChangeRate>) => params.row.name,
                minWidth: 350,
                fullWidth: true
              }),
              COLUMN_TYPES.NUMBER({
                field: 'rate',
                label: t('settings.changeRate.modal.table.rate'),
                width: 200
              }),
              COLUMN_TYPES.NUMBER({
                field: t('settings.changeRate.modal.table.value'),
                valueGetter: (params: GridValueGetterParams<ChangeRate>) => NumberExt.round(valueForNCHF / params.row.rate * params.row.multiplier, 2),
                width: 200
              }),
              COLUMN_TYPES.TEXT({
                field: 'currency',
                label: t('settings.changeRate.modal.table.currencyCode'),
                width: 100
              }),
            ]}
            data={changeRates}
            disablePagination={true}
            disableRowSelection={true}
          />
        </Stack>
      )}
    />
  );
};

export default ChangeRateListModal;
